import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export const RedirectPage = () => {
    const [count, setCount] = useState(10);
    const navigate = useNavigate();
    const timerRef = useRef<any>(null);

    useEffect(() => {
        timerRef.current = setTimeout(() => {
            setCount((prevCount) => {
                if (prevCount <= 0) {
                    navigate("/dashboard");
                    return prevCount;  // Stop the timer if count reaches 5
                }
                return prevCount - 1;
            });
        }, 1000);

        return () => clearTimeout(timerRef.current);  // Cleanup function to clear the timer when the component unmounts
    }, [count]);

    return (
        <>
            <div className="flex flex-column md:flex-column md:justify-content-between md:align-items-center pt-5">
                <h1>From Now Timesheet's can be Added, Upadte and Verify from <span className="text-blue-500">Show PO</span> module</h1>
                <Button label="Go To Show PO page." onClick={() => {
                    clearTimeout(timerRef.current);
                    navigate("/showPurchase");
                }} />
                <h3>Or</h3>
                <h3>You Will Be Redirected to dasboard in : <span className="text-blue-500">{count}</span> seconds</h3>
            </div>
        </>
    );
}